import { createFileRoute } from "@tanstack/react-router";

import { AuthPlaceholder } from "../auth/auth-placeholder.tsx";

export const Route = createFileRoute("/s/$token")({
  component: AuthPlaceholder,
});
